export { default as useCacheLifestyleDetections } from './useCacheLifestyleDetections';
